import { rescheduleAppointment } from './appointmentAction';
import {
    BOOK_APPOINTMENT_ERROR,
    BOOK_APPOINTMENT_START,
    BOOK_APPOINTMENT_SUCCESS,
    GET_BUSINESS_APP_ERROR,
    GET_BUSINESS_APP_START,
    GET_BUSINESS_APP_SUCCESS,
    GET_APPOINTMENTS,
    PENDING_APPOINTMENTS,
    REJECTED_APPOINTMENTS,
    CANCEL_APPOINTMENT_LOADING,
    PREVIOUS_APP_PENDING,
    PREVIOUS_APP_ERROR,
    PREVIOUS_APP_SUCCESS,
    RESCHEDULE_APPOINTMENT_LOADING,
    BOOKING_STATS_PENDING,
    BOOKING_STATS_SUCCESS,
    BOOKING_STATS_ERROR,
    DASHBOARD_STATS_PENDING,
    DASHBOARD_STATS_SUCCESS,
    DASHBOARD_STATS_ERROR,
    EMAIL_STATS_PENDING,
    EMAIL_STATS_SUCCESS,
    EMAIL_STATS_ERROR,
    GET_AVAILABLE_SLOTS_START,
    GET_AVAILABLE_SLOTS_SUCCESS,
    GET_AVAILABLE_SLOTS_ERROR,
} from './types';

const initialState = {
    cutomerAppointments: [],
    isLoading: false,
    todayAppointments: [],
    upcomingAppointments: [],
    previousAppointments: [],
    isCancellingAppointment: false,
    isEditingAppointment: false,
    bookingStatsLoading: false,
    dashboardStatsLoading: false,
    emailStatsLoading: false,
    availableSlotsLoading: false,
    availableSlots: [],
    bookingStats: {
        customerBooking: 0,
        manualBooking: 0,
        aiAgentBooking: 0,
    },
    dashboardStats: {
        todayRevenue: 0,
        yesterdayRevenue: 0,
        dayOverDayChangePercent: 0,
        trend: 'profit',
        agentWeeklyBooking: 0,
    },
    emailStats: {
        totalEmailsSent: 0,
        bookingsCount: 0,
        revenueGenerated: 0,
    },
};

const appointmentReducer = (state = initialState, action) => {
    switch (action.type) {
        case BOOK_APPOINTMENT_START:
        case PENDING_APPOINTMENTS:
        case PREVIOUS_APP_PENDING:
        case GET_BUSINESS_APP_START:
            return {
                ...state,
                isLoading: true,
            };

        // =======GET BUSINESS APPOINTMENT=========
        case GET_BUSINESS_APP_SUCCESS:
            return {
                ...state,
                isLoading: false,
                todayAppointments: action.payload.todayAppointments,
                upcomingAppointments: action.payload.upcomingAppointments,
            };

        // =======GET CUSTOMER APPOINTMENTS=========
        case GET_APPOINTMENTS:
            return {
                ...state,
                isLoading: false,
                cutomerAppointments: action.payload,
            };

        // =======PREVIOUS APPOINTMENTS=========
        case PREVIOUS_APP_SUCCESS:
            return {
                ...state,
                isLoading: false,
                previousAppointments: action.payload,
            };
        case CANCEL_APPOINTMENT_LOADING:
            return {
                ...state,
                isCancellingAppointment: action.payload,
            };

        case BOOK_APPOINTMENT_SUCCESS:
        case BOOK_APPOINTMENT_ERROR:
        case GET_BUSINESS_APP_ERROR:
        case REJECTED_APPOINTMENTS:
        case PREVIOUS_APP_ERROR:
            return {
                ...state,
                isLoading: false,
            };

        // =======RESCHEDULE BUSINESS APPOINTMENT=========
        case RESCHEDULE_APPOINTMENT_LOADING:
            return {
                ...state,
                isEditingAppointment: action.payload,
            };

        // =======BOOKING STATS=========
        case BOOKING_STATS_PENDING:
            return {
                ...state,
                bookingStatsLoading: true,
            };
        case BOOKING_STATS_SUCCESS:
            return {
                ...state,
                bookingStats: {
                    customerBooking: action.payload.customerBooking,
                    manualBooking: action.payload.manualBooking,
                    aiAgentBooking: action.payload.aiAgentBooking,
                },
                bookingStatsLoading: false,
            };
        case BOOKING_STATS_ERROR:
            return {
                ...state,
                bookingStats: {
                    customerBooking: 0,
                    manualBooking: 0,
                    aiAgentBooking: 0,
                },
                bookingStatsLoading: false,
            };

        // =======DASHBOARD STATS=========
        case DASHBOARD_STATS_PENDING:
            return {
                ...state,
                dashboardStatsLoading: true,
            };
        case DASHBOARD_STATS_SUCCESS:
            return {
                ...state,
                dashboardStats: {
                    todayRevenue: action.payload.todayRevenue,
                    yesterdayRevenue: action.payload.yesterdayRevenue,
                    dayOverDayChangePercent: action.payload.dayOverDayChangePercent,
                    trend: action.payload.trend,
                    agentWeeklyBooking: action.payload.agentWeeklyBooking,
                },
                dashboardStatsLoading: false,
            };
        case DASHBOARD_STATS_ERROR:
            return {
                ...state,
                dashboardStats: {
                    todayRevenue: 0,
                    yesterdayRevenue: 0,
                    dayOverDayChangePercent: 0,
                    trend: 'profit',
                    agentWeeklyBooking: 0,
                },
                dashboardStatsLoading: false,
            };

        // =======EMAIL STATS=========
        case EMAIL_STATS_PENDING:
            return {
                ...state,
                emailStatsLoading: true,
            };
        case EMAIL_STATS_SUCCESS:
            return {
                ...state,
                emailStats: {
                    totalEmailsSent: action.payload.totalEmailsSent,
                    bookingsCount: action.payload.bookingsCount,
                    revenueGenerated: action.payload.revenueGenerated,
                },
                emailStatsLoading: false,
            };
        case EMAIL_STATS_ERROR:
            return {
                ...state,
                emailStats: {
                    totalEmailsSent: 0,
                    bookingsCount: 0,
                    revenueGenerated: 0,
                },
                emailStatsLoading: false,
            };

        // =======AVAILABLE SLOTS=========
        case GET_AVAILABLE_SLOTS_START:
            return {
                ...state,
                availableSlotsLoading: true,
            };
        case GET_AVAILABLE_SLOTS_SUCCESS:
            return {
                ...state,
                availableSlots: action.payload,
                availableSlotsLoading: false,
            };
        case GET_AVAILABLE_SLOTS_ERROR:
            return {
                ...state,
                availableSlots: [],
                availableSlotsLoading: false,
            };

        default:
            return state;
    }
};

export default appointmentReducer;
